// @ts-strict-ignore
import { removeWhitespaceAndSpecialChars } from '../helpers/commons'
import loadable from '@loadable/component'
import React from 'react'

const AboutAuthorCard = loadable(() => import('./about-author-card'))
const AuthorEditorCard = loadable(() => import('./author-editor-card'))
const AuthorSnippet = loadable(() => import('./author-snippet'))
const Awards = loadable(() => import('./awards'))
const Bundle = loadable(() => import('./bundle'))
const Calculator = loadable(() => import('./calculator'))
const CallOutCard = loadable(() => import('./call-out-card'))
const CallOutBanner = loadable(() => import('./call-out-banner'))
const CardCarousel = loadable(() => import('./card-carousel'))
const CardFinderLowProminence = loadable(() => import('./card-finder/low-prominence'))
const FeaturedIn = loadable(() => import('./featured-in-module'))
const FootNotesModule = loadable(() => import('./foot-notes'))
const GuestQuoteSnippet = loadable(() => import('./guest-quote-snippet'))
const GuidesModule = loadable(() => import('./guides-module'))
const HeaderModule = loadable(() => import('./header-module'))
const ImageCarousel = loadable(() => import('./image-carousel'))
const ImageViewer = loadable(() => import('./image-viewer'))
const LinkCollectionModule = loadable(() => import('./link-collection'))
const LoanRepaymentCalculator = loadable(() => import('./loan-repayment-calculator'))
const PlatinumPrimaryBillboard = loadable(() => import('./primary-billboard'))
const PpcNav = loadable(() => import('./ppc-nav'))
const ProductNavigation = loadable(() => import('./product-navigation'))
const ProsConsCard = loadable(() => import('./pros-cons-card'))
const SectionAuthor = loadable(() => import('./section-author'))
const SelectedBundle = loadable(() => import('./selected-bundle'))
const StatSnippet = loadable(() => import('./stat-snippet'))
const StickyBanner = loadable(() => import('./sticky-banner'))
const StickyNav = loadable(() => import('./sticky-nav'))
const TriageModule = loadable(() => import('./triage-module'))
const TrustPilotReviews = loadable(() => import('./trustpilot'))
const WhyChooseUS = loadable(() => import('./why-choose-us-module'))
const YoutubeLite = loadable(() => import('./youtube-lite-module'))

export enum Module {
  CallOutCard = 'call-out-card',
  CallOutBanner = 'call-out-banner',
  CardCarousel = 'card-carousel',
  FootNotesModule = 'foot-notes-module',
  HeaderModule = 'header-module',
  ProductNavigation = 'product-navigation',
  aboutTheAuthor = 'about-the-author',
  authorEditorCardModule = 'author-editor-card-module',
  awards = 'awards',
  calculator = 'calculator',
  creditCardCalculator = 'credit-card-calculator',
  creditCardFinderModule = 'credit-card-finder-module',
  creditCardFinderModuleLowProminence = 'credit-card-finder-module-low-prominence',
  featuredIn = 'featured-in',
  guestQuoteSnippet = 'guest-quote-snippet',
  guidesModule = 'guides-module',
  imageCarousel = 'image-carousel',
  imageViewer = 'image-viewer',
  linkCollectionModule = 'link-collection-module',
  loanRepaymentCalculator = 'loan-repayment-calculator',
  ppcNav = 'ppc-nav',
  primaryBillboard = 'primary-billboard',
  prosAndConsModule = 'pros-and-cons-module',
  quoteSnippet = 'quote-snippet',
  sectionAuthor = 'section-author',
  statSnippet = 'stat-snippet',
  stickyBanner = 'sticky-banner',
  stickyNav = 'sticky-nav',
  travelMoneyCalculator = 'travel-money-calculator',
  triageModule = 'triage-module',
  trustpilot = 'trustpilot',
  whyChooseUsModule = 'why-choose-us-module',
  youtubeLite = 'youtube-lite',
  bundle = 'bundle',
  selectedBundle = 'selected-bundle',
}

export interface PlatinumModulesProps {
  variant: Module
  jsonBody: any
  name: string
  newSection?: boolean
  sys: any
  dataset: any
  content: any
  brand: string
}

function findModule({
  name,
  variant,
  jsonBody,
  sys,
  dataset,
  content,
  form,
  showHeader = true,
  brand,
}) {
  const formattedName = removeWhitespaceAndSpecialChars(name)

  const moduleMap = {
    'about-the-author': AboutAuthorCard,
    'author-editor-card-module': AuthorEditorCard,
    bundle: Bundle,
    'call-out-card': CallOutCard,
    'call-out-banner': CallOutBanner,
    'card-carousel': CardCarousel,
    'credit-card-finder-module-low-prominence': CardFinderLowProminence,
    'featured-in': FeaturedIn,
    'foot-notes-module': FootNotesModule,
    'guest-quote-snippet': GuestQuoteSnippet,
    'guides-module': GuidesModule,
    'header-module': HeaderModule,
    'image-carousel': ImageCarousel,
    'image-viewer': ImageViewer,
    'link-collection-module': LinkCollectionModule,
    'loan-repayment-calculator': LoanRepaymentCalculator,
    'ppc-nav': PpcNav,
    'primary-billboard': PlatinumPrimaryBillboard,
    'product-navigation': ProductNavigation,
    'pros-and-cons-module': ProsConsCard,
    'quote-snippet': AuthorSnippet,
    'section-author': SectionAuthor,
    'selected-bundle': SelectedBundle,
    'stat-snippet': StatSnippet,
    'sticky-banner': StickyBanner,
    'sticky-nav': StickyNav,
    'triage-module': TriageModule,
    'why-choose-us-module': WhyChooseUS,
    'youtube-lite': YoutubeLite,
    awards: Awards,
    calculator: Calculator,
    trustpilot: TrustPilotReviews,
  }

  const Component = moduleMap[variant]

  if (Component) {
    return (
      <Component
        jsonBody={jsonBody}
        content={content}
        name={formattedName}
        variant={variant}
        rawName={name}
        sys={sys}
        dataset={dataset}
        form={form}
        showHeader={showHeader}
        brand={brand}
      />
    )
  } else {
    return <></>
  }
}

const PlatinumModules: React.FC<PlatinumModulesProps> = ({
  variant,
  jsonBody,
  name,
  newSection = false,
  sys,
  dataset,
  content,
  form,
  brand,
}) => {
  const module = findModule({
    name,
    variant,
    jsonBody,
    sys,
    dataset,
    content,
    form,
    brand,
  })

  if (newSection) {
    return <div className='NewSectionWrapper'>{module}</div>
  } else {
    return module
  }
}
export default PlatinumModules
